/* eslint-disable no-console */
class AbstractTracker {
  setUser (user) {
    console.debug(`setUser with user ${user} on AbstractTracker`);
  }

  setRole (role) {
    console.debug(`setRole with role ${role} on AbstractTracker`);
  }

  track (eventName, eventPayload = {}) {
    console.debug(`Track ${eventName} with payload ${eventPayload} on AbstractTracker`);
  }
}

export default AbstractTracker;
